module.exports = __webpack_public_path__ + "static/media/emptystar.6d3f2a01.svg";